import { FieldLabel, FormField, Text } from '@dixa/lib-shared-habla';

import { AutoRepliesExceptionListItem } from 'components/powerFlowShared/components/modals/businesshours/components/autoReplies/autoRepliesExceptionListItem';

import { Item, ListItem } from '../listItem/listItem';

import styles from './autoReplies.module.scss';

export type AutoRepliesProps = {
  isPhoneNode: boolean;
  listItems?: {
    default: null | Item;
    exceptions: Item[];
  };
  isScheduleLoading: boolean;
  hasAnyTemplates: boolean;
  hasDefaultTemplate: boolean;
};

/**
 * A component that displays a list of `audio messages` or `auto-replies`
 * connected with a schedule.
 */
export function AutoReplies({
  isPhoneNode,
  listItems,
  isScheduleLoading,
  hasAnyTemplates,
  hasDefaultTemplate,
}: AutoRepliesProps): JSX.Element {
  return (
    <FormField>
      {isPhoneNode ? (
        <FieldLabel
          helpIcon={{
            delayDuration: 500,
            title: 'Audio messages (schedule)',
            text: 'Customers will hear these audio-messages when they call you outside your business hours. You can set auto-replies in your schedule.',
          }}
        >
          Audio messages connected to this schedule
        </FieldLabel>
      ) : (
        <FieldLabel
          helpIcon={{
            delayDuration: 500,
            title: 'Auto-replies (schedule)',
            text: 'Customers will receive these auto-replies when they email you outside your business hours. You can set auto-replies in your schedule.',
          }}
        >
          Auto-replies connected to this schedule
        </FieldLabel>
      )}
      <div className={styles.listItems}>
        {isPhoneNode && listItems?.default && (
          <ListItem
            isBold
            isLoading={isScheduleLoading}
            item={listItems.default}
          />
        )}
        {!isPhoneNode && (
          <>
            {hasAnyTemplates && listItems?.default ? (
              <ListItem
                isBold
                isLoading={isScheduleLoading}
                item={listItems.default}
                withBackground={hasDefaultTemplate}
              />
            ) : (
              <Text.Paragraph subdued variant="2">
                No auto-replies set
              </Text.Paragraph>
            )}
          </>
        )}
        {listItems?.exceptions?.map((listItem) => (
          <AutoRepliesExceptionListItem key={listItem.name} item={listItem} />
        ))}
      </div>
    </FormField>
  );
}
